import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45dcd7d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "commentbox__wrapper" }
const _hoisted_2 = { class: "commentbox__left" }
const _hoisted_3 = { class: "commentbox__img" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "msg__notification" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "commentbox__heading" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "All Comments")
], -1))
const _hoisted_7 = { class: "commentbox__right" }
const _hoisted_8 = { class: "commentbox__section" }
const _hoisted_9 = { class: "commentbox__message" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "commentbox__projects" }
const _hoisted_12 = { class: "commentbox__projects__title" }
const _hoisted_13 = { class: "commentbox__bottom__chats__list" }
const _hoisted_14 = { class: "commentbox__left" }
const _hoisted_15 = { class: "commentbox__img" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "commentbox__bottom__chats__lists" }
const _hoisted_18 = { class: "commentbox__bottom__chats__list__item" }
const _hoisted_19 = { class: "commentbox__center" }
const _hoisted_20 = { class: "commentbox__heading" }
const _hoisted_21 = { class: "commentbox__right" }
const _hoisted_22 = { class: "commentbox__bottom__chats__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserProfileLogo = _resolveComponent("UserProfileLogo")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, {
      class: _normalizeClass(["commentbox__inner", { commentbox_active: $setup.isOpenComment }]),
      variant: "flat"
    }, {
      text: _withCtx(() => [
        _createElementVNode("div", {
          class: "commentbox__top",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.isOpenComment = !$setup.isOpenComment))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              ($setup.userWorkStationImage)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: $setup.userWorkStationImage
                  }, null, 8, _hoisted_4))
                : (_openBlock(), _createBlock(_component_UserProfileLogo, {
                    key: 1,
                    userName: $setup.activeUserWorkstation?.name
                  }, null, 8, ["userName"]))
            ]),
            _hoisted_5,
            _hoisted_6
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_v_icon, { icon: "mdi-chevron-down" })
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.projectComments, (commentRoom, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "commentbox__bottom",
                key: commentRoom?.id
              }, [
                _createElementVNode("div", {
                  class: "commentbox__bottom__chats",
                  onClick: _withModifiers(($event: any) => (
                  $setup.openActiveComment(
                    commentRoom?.elementId,
                    commentRoom?.userComments[0].id
                  )
                ), ["stop"])
                }, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("p", null, "#" + _toDisplayString(index + 1) + " - Project ID: #" + _toDisplayString($props.projectId), 1),
                      ($setup.isShowResolve(commentRoom?.userWorkstation?.id))
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 0,
                            icon: "mdi-check-circle-outline",
                            onClick: ($event: any) => ($setup.resolveUserComments(commentRoom?.id))
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        (commentRoom?.userWorkstation?.profileImage)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: 
                          $setup.getWorkStationImagePublicUrl(
                            commentRoom?.userWorkstation
                          )
                        ,
                              alt: ""
                            }, null, 8, _hoisted_16))
                          : (_openBlock(), _createBlock(_component_UserProfileLogo, {
                              key: 1,
                              userName: _ctx.comment?.userWorkstation?.name
                            }, null, 8, ["userName"]))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("h6", null, _toDisplayString(commentRoom?.userWorkstation?.name), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("span", null, _toDisplayString($setup.timeCommentAgo(
                            commentRoom?.userComments[0]?.dateCreated
                          )), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("p", null, _toDisplayString(commentRoom?.userComments[0]?.comment), 1)
                      ])
                    ])
                  ])
                ], 8, _hoisted_10)
              ]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["class"])
  ]))
}